module.exports = __webpack_public_path__ + "media/images/lb/085-6628034f3c26edaf42770948e4274960.svg";